import { Box, Grid } from "@mui/material";
import { clearOpenSections } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { fetchmembersInfo } from "components/common/Filters/Filters.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import PageTitle from "components/common/PageTitle";
import ScrollAwareHeader from "components/common/ScrollAwareHeader";
import Typography from "components/common/Typography";
import SearchAppBar from "components/common/searchBar";
import { isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { DEFAULT_CORP_INNCODE, PAGE_SIZE, minSearchStrLength } from "utils/CommonConstants";
import { planTypes } from "utils/Types";
import AbovePropertyList from "./AboveProperty";
import CreateMyPlan from "./Create";
import List from "./list";
import { fetchMyPlansAsync } from "./myplans.slice";

const Index = () => {
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const searchText = useAppSelector((state) => state.app.searchText);
  const [inputText, setInputText] = useState(searchText);
  const innCode = useAppSelector((state) => state.app.innCode);
  const { isAbovePropertyUser, isConsultant, isCorp }: any = useAppSelector((state) => state.app.loggedInUserDetails);
  const status = useAppSelector((state) => state.formDetails.addToMyPlans.status);
  const initialBookMarkInncodes = useAppSelector((state) => state.Dashboard.bookMarkInncodes);
  const selectedAdminInncodes = useAppSelector((state) => state.myplans.MyPlans.selectedAdminInncodes);
  const globalFiltersforPage = useAppSelector(
    (state) => state.globalFilters[isCorp ? filterPage.consultantInncodePlansDisplay : filterPage.inncodePlansDisplay]
  );

  const innCodes = () => {
    if (innCode === DEFAULT_CORP_INNCODE) {
      return selectedAdminInncodes?.length > 0
        ? selectedAdminInncodes?.map((item: any) => item?.innCode)
        : initialBookMarkInncodes?.map((item: any) => item?.innCode);
    } else {
      return innCode;
    }
  };

  useEffect(() => {
    if (isCorp && isEmpty(globalFiltersforPage.modifiedFilter) && !isEmpty(innCodes()))
      dispatch(
        setPageFilter({
          pageName: filterPage.consultantInncodePlansDisplay,
          modifiedFilter: [
            {
              id: 36,
              options: innCodes(),
              key: "innCode",
              name: "Inncode"
            }
          ]
        })
      );
  }, []);

  useEffect(() => {
    dispatch(clearOpenSections());
  }, [dispatch]);

  useEffect(() => {
    if (status === "success" && !isAbovePropertyUser) {
      const props = {
        page: 0,
        size: PAGE_SIZE
      };

      dispatch(fetchMyPlansAsync(props));
    }
  }, [dispatch, status]);

  const getInputDetails = (input: string) => {
    if (input.length > minSearchStrLength || !input) {
      setInputText(input);
    }
  };

  const getMembersList = (searchValue: string) => {
    const props = {
      searchText: searchValue,
      page: 0,
      size: 100
    };
    dispatch(fetchmembersInfo(props));
  };

  const getScrollHeaderContent = () => {
    return (
      <ScrollAwareHeader>
        {!isAbovePropertyUser && (
          <Grid
            display="flex"
            alignItems={isMobileScreen ? "stretch" : "center"}
            flexDirection={isMobileScreen ? "column" : "row"}
            width="100%"
            gap="8px"
          >
            <Box
              display="flex"
              flexDirection={isMobileScreen ? "column" : "row"}
              justifyContent="space-between"
              alignItems={isMobileScreen ? "stretch" : "center"}
              flex="1"
              minWidth={0}
              gap="8px"
            >
              <SearchAppBar
                value={inputText}
                getInputDetails={getInputDetails}
                divider
                planType={planTypes.MyPlans}
                sx={{
                  border: `1px solid ${tokens.Draggable.General.Background}`,
                  width: isMobileScreen ? "100%" : "350px"
                }}
              />
              <Box
                display="flex"
                justifyContent={isMobileScreen ? "flex-end" : "flex-start"}
                width={isMobileScreen ? "100%" : "auto"}
              >
                <GlobalFilters
                  page={isCorp ? filterPage.consultantInncodePlansDisplay : filterPage.inncodePlansDisplay}
                  getMembersList={getMembersList}
                />
              </Box>
            </Box>
            {!isCorp && !isConsultant && !isMobileScreen && <CreateMyPlan />}
          </Grid>
        )}
      </ScrollAwareHeader>
    );
  };

  return (
    <>
      <Box marginTop={"32px"}>
        {getScrollHeaderContent()}
        <Grid container display="flex" alignItems={"center"} justifyContent={"space-between"}>
          <Box></Box>
          <PageTitle label={isCorp ? "Inncode Plans" : "My Plans"} />
          {!isCorp && !isConsultant && !isMobileScreen ? <CreateMyPlan /> : <Box></Box>}
        </Grid>
        <Grid container display="flex" gap="16px">
          {!isAbovePropertyUser && (
            <>
              <Grid item sm={3} xs={12}>
                <SearchAppBar
                  value={inputText}
                  getInputDetails={getInputDetails}
                  divider
                  planType={planTypes.MyPlans}
                ></SearchAppBar>
              </Grid>
              <Box marginLeft={"auto"}>
                <GlobalFilters
                  page={isCorp ? filterPage.consultantInncodePlansDisplay : filterPage.inncodePlansDisplay}
                  getMembersList={getMembersList}
                />
              </Box>
            </>
          )}
        </Grid>
        {!isAbovePropertyUser && (
          <GlobalFilterDescription
            bgColor={tokens.Background.General.Primary}
            page={isCorp ? filterPage.consultantInncodePlansDisplay : filterPage.inncodePlansDisplay}
          />
        )}
        {inputText && (
          <Box marginLeft={"10px"} marginTop={"30px"} display="flex" flexDirection={"row"} gap="5px">
            <Typography variant={"body1"}>Showing search results for</Typography>
            <Typography variant={"body1"} showBold>
              "{inputText}"
            </Typography>
          </Box>
        )}
        <Grid marginTop={isMobileScreen ? "45px" : "30px"} container>
          {isAbovePropertyUser ? <AbovePropertyList /> : <List />}
        </Grid>
      </Box>
      {isMobileScreen && <CreateMyPlan />}
    </>
  );
};

export default Index;
